/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Option_Do_Not_PublishInputs */



/**
* | output |
* | --- |
* | "Do Not Publish" |
*
* @param {Work_Order_Publish_Option_Do_Not_PublishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_option_do_not_publish = /** @type {((inputs?: Work_Order_Publish_Option_Do_Not_PublishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Option_Do_Not_PublishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ne pas publier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht veröffentlichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non pubblicare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не публиковать")
	if (locale === "es") return /** @type {LocalizedString} */ ("No publicar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请勿发布")
	if (locale === "ja") return /** @type {LocalizedString} */ ("公開しないでください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रकाशित न करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não publicar")
	return /** @type {LocalizedString} */ ("Do Not Publish")
});